import React, { useContext, useEffect, useState } from "react";
import { Context } from "../../utils/context";
import { MdClose } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { removeFromWishlist } from "../../utils/feature/wishlistSlice";

const Wishlist = () => {
  const { cartItems, handleAddToCart } = useContext(Context);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const quantity = 1;
  return (
    <div className="cart-products cursor-pointer min-h-screen w-full">
      <h1 className=" text-center  text-4xl py-10">Wishlist</h1>
      {cartItems === "" ? (
        <div className=" min-h-screen flex justify-center items-center">
          {" "}
          No Item In Wishlist
        </div>
      ) : (
        ""
      )}
      {cartItems?.map((item) => (
        <div
          className="search-result-item     flex  max-w-4xl mx-auto bg-white justify-around"
          key={item._id}
        >
          <div className="image-containe w-40 ">
            <img
              className=" "
              src={item.images?.featuredImage?.src}
              alt={item.name}
            />
          </div>
          <div className="prod-details ">
            <span
              className="name"
              onClick={() => navigate(`/product/${item._id}`)}
            >
              {item.name}
            </span>
            <MdClose
              className="close-btn"
              onClick={() => dispatch(removeFromWishlist(item))}
            />

            <div className="text">
              <span className="highlight">
                <span>&#8377;</span>
                {item.price}
              </span>
            </div>
            <button
              onClick={() => handleAddToCart(item, quantity)}
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 text-xs md:text-lg rounded absolute bottom-0 nd:bottom-5 right-0"
            >
              Add To Cart
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Wishlist;
